import React from "react";
import Banner from "../Components/Banner";

const policies = [
  {
    title: "1. Introduction",
    text: "This Privacy Policy explains how HNH Soft Tech Solutions Pvt. Ltd. collects, uses, and protects personal information when you use our website or services. We are committed to safeguarding your privacy and ensuring that your personal data is handled securely and in accordance with applicable data protection laws.",
  },
  {
    title: "2. Information We Collect",
    text: "We may collect personal information including your name, email address, phone number, company name, and other details that you voluntarily provide through our contact forms. We may also collect technical information such as IP address, browser type, device information, and website usage data.",
  },
  {
    title: "3. How We Use Your Information",
    text: "We use the collected information to respond to inquiries, provide requested services, improve our website, communicate with clients, and maintain business records. Your information helps us deliver better digital solutions and customer support.",
  },
  {
    title: "4. Lawful Basis for Processing",
    text: "We process personal data under lawful bases including your consent, the necessity to perform a contract, legitimate business interests, and compliance with legal obligations where required.",
  },
  {
    title: "5. Data Protection Principles",
    text: "HNH Soft Tech Solutions Pvt. Ltd. follows key data protection principles including transparency, fairness, purpose limitation, data minimization, accuracy, storage limitation, and security to ensure responsible handling of personal data.",
  },
  {
    title: "6. Data Sharing",
    text: "We do not sell or rent personal data to third parties. Information may only be shared with trusted service providers involved in delivering our services, or when required by law or regulatory authorities.",
  },
  {
    title: "7. Data Retention",
    text: "Personal data is retained only for as long as necessary to fulfill the purposes for which it was collected, including legal, accounting, or reporting requirements.",
  },
  {
    title: "8. Cookies and Tracking Technologies",
    text: "Our website may use cookies and similar tracking technologies to improve functionality, analyze website traffic, and enhance the overall user experience. You can control cookie preferences through your browser settings.",
  },
  {
    title: "9. Your Data Protection Rights",
    text: "Depending on your location, you may have rights regarding your personal data including the right to access, correct, delete, or restrict processing of your personal information. You may also request a copy of the data we hold about you.",
  },
  {
    title: "10. Security Measures",
    text: "We implement appropriate technical and organizational security measures to protect personal information from unauthorized access, misuse, alteration, or disclosure.",
  },
  {
    title: "11. Changes to This Policy",
    text: "HNH Soft Tech Solutions Pvt. Ltd. reserves the right to update this Privacy Policy from time to time. Any updates will be published on this page.",
  },
  {
    title: "12. Contact Information",
    text: `If you have any questions about this Privacy Policy or how your data is handled, please contact us at info@hnhsofttechsolutions.com or visit our office at Office #402 4th Floor plot# 172-M, Block-2 P.E.C.H.S. Employees Co-operate Bahadurabad.`,
  },
];

const PrivacyPolicy = () => {
  return (
    <>
      <Banner heading="Privacy Policy" text="Privacy Policy" />

      <section className="py-20 px-4 bg-gray-50 font-sans">
        <div className="px-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#025383] mb-4">Privacy Policy</h2>
            <p className="text-gray-800 text-center text-xl">Learn how we collect, use, and protect your personal information.</p>
          </div>

          <div className="space-y-6">
            {policies.map((item, index) => (
              <div
                key={index}
                className="bg-white border-l-[6px] border-[#025383] rounded-2xl p-6 sm:p-8 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_25px_rgba(2,83,131,0.12)] transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#025383]/10 flex items-center justify-center text-[#025383] text-xl font-bold">
                    {index + 1}
                  </div>
                  <h3 className="text-[#025383] text-2xl font-bold">
                    {item.title.replace(/^\d+\.\s*/, '')}
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed text-[17px] sm:pl-16">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;